import React, { useMemo } from 'react'
import injectStyles from 'react-jss'
import { withRouter, Link } from 'react-router-dom'

import Box from '@material-ui/core/Box'
import Grid from '@material-ui/core/Grid'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import CardActionArea from '@material-ui/core/CardActionArea'
import Typography from '@material-ui/core/Typography'

import { PageTitle } from 'Components/PageTitle'
import { LayoutDashboard } from 'Components/Layout/Dashboard'
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator'

import { HideWhenBlocked } from 'Containers/UIBlock/HideWhenBlocked'

import CountriesIcon from 'Assets/Images/icons/countries'

import styles from './styles'
import StyledBreadcrumbs from '../../Components/StyledBreadcrumbs'

const CountryList = ({ classes, match, countries }) => {
  const sortedCountriesList = useMemo(() => {
    return countries.sort((a, b) => a.name.localeCompare(b.name))
  }, [countries])

  return (
    <LayoutDashboard>
      <HideWhenBlocked>
        <StyledBreadcrumbs
          icon={<CountriesIcon style={{ width: 24 }} />}
          breadcrumbs={[
            {
              label: 'Countries',
            },
          ]}
        />
        <PageTitle>Countries</PageTitle>
        {sortedCountriesList.length ? (
          <Grid container spacing={3}>
            {sortedCountriesList.map(country => (
              <Grid item xs={6} md={3} key={country.id}>
                <Card className={classes.countryCardWrapper}>
                  <Link
                    to={`${match.url}/${country.id}/global-planing`}
                    title={`View ${country.name}`}
                    className={classes.countryLink}
                  >
                    <CardActionArea>
                      <CardContent>
                        <Typography className={classes.countryName}>
                          {country.name}
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Link>
                </Card>
              </Grid>
            ))}
          </Grid>
        ) : (
          <Box height={600}>
            <LoadingIndicator />
          </Box>
        )}
      </HideWhenBlocked>
    </LayoutDashboard>
  )
}

export default withRouter(injectStyles(styles)(CountryList))
